/**
 * Real brand assets uploaded by Ralph (Gladiateurs du Nord, Impact Élite Martial).
 * Centralized for easy reference and updates.
 */

export const BRAND_ASSETS = {
  // Logo Gladiateurs du Nord (casque doré + texte grunge noir)
  GLADIATEURS_LOGO: "https://customer-assets.emergentagent.com/job_social-ads-manager/artifacts/r2hi52y6_A11C0BFD-CA37-459F-8CA4-0E3ABE9A58AC.jpeg",
  // Texte "Grand Prix Gladiateurs du Nord Provincial"
  GRAND_PRIX_TEXT: "https://customer-assets.emergentagent.com/job_social-ads-manager/artifacts/2fczkcn8_94BAD223-DB4F-4424-89AF-F6953425C976.jpeg",
  // Affiche combat principal — Mattson Léon vs Chevalier Guevara (WKN 147 lbs)
  POSTER_MAIN: "https://customer-assets.emergentagent.com/job_social-ads-manager/artifacts/rmuefyoh_A8A2C121-8B15-4EBF-A135-97B6743B4AD3.jpeg",
  // Affiche combat vedette secondaire — Simon Lefebvre vs Djime Moussa (ISKA 175 lbs)
  POSTER_COFEATURE: "https://customer-assets.emergentagent.com/job_social-ads-manager/artifacts/xyjn368u_2AE25865-3299-4CB6-B963-8840E680DCE6.jpeg",
  // Plan de salle Aréna Kiwanis Val-d'Or (servi en local, fichier converti depuis HEIC)
  ARENA_MAP: "/arena-kiwanis-plan-salle.jpg",
  // Logo officiel Institut Impact Élite Martial (cercle rouge/noir, silhouettes combattants)
  DOJO_LOGO: "/dojo-logo-impact.jpeg",
  // Logo maître officiel (sept. 2026) — bloc texte transparent (fond sombre) + bandeau des 5 pastilles
  MASTER_TEXT: "/logos/master_text_sm.webp",
  MASTER_PASTILLES: "/logos/master_pastilles_sm.webp",
  MASTER_FULL: "/logos/master_wordmark.webp",
  // ===== KAIZEN SYSTEM LOGOS (officiels 28 mai 2026) =====
  KAIZEN_SYSTEM_PRINCIPAL: "/logos/kaizen_system/kaizen_system_logo_principal.jpg",
  KAIZEN_SYSTEM_VARIATIONS_BW: "/logos/kaizen_system/kaizen_system_logo_variations_bw.jpg",
  KAIZEN_SYSTEM_BANNER_DISCIPLINES: "/logos/kaizen_system/kaizen_system_banner_disciplines.jpg",
};

// Palette officielle KAIZEN SYSTEM (Bible Brand 28 mai 2026)
export const KAIZEN_COLORS = {
  black: "#0a0a0a",       // base
  white: "#fafafa",       // respiration
  redImpact: "#dc2626",   // énergie / combat
  goldAccent: "#f59e0b",  // élite (ACCENT seulement)
};

// Hiérarchie de marque officielle (non-négociable)
export const BRAND_HIERARCHY = {
  parent: "Institut Impact Élite Martial",
  system: "Kaizen System",
  subBrands: ["Muay Thai", "Brazilian Jiu-Jitsu RDJP", "Jiu-jitsu Can Ryu", "Kick-Boxing", "Powerkick Her"],
};

export const EVENT_INFO = {
  name: "Gladiateurs du Nord V",
  date: "16 mai 2026",
  location: "Aréna Kiwanis · Val-d'Or, QC",
  doors: "18h00",
  firstFight: "19h30",
  ticketUrl: "https://institutimpactelitemartial.com/billetterie/",
  officialSiteUrl: "https://institutimpactelitemartial.com",
};

// Identifiants publics des comptes officiels (safe en frontend, ne donnent pas d'accès)
export const SOCIAL_ACCOUNTS = {
  facebookPageId: "61563072224219",   // Page "Institut Impact Élite Martial" — ID officiel confirmé via URL photo 24 mai 2026
  facebookPageName: "Institut Impact Élite Martial",
  facebookPageUrl: "https://www.facebook.com/profile.php?id=61563072224219",
  instagramProfileId: "71807387947",
  instagramHandle: "institutimpactelitemartial",
  instagramUrl: "https://www.instagram.com/institutimpactelitemartial/",
  tiktokHandle: "impactelitenord",
  tiktokUrl: "https://www.tiktok.com/@impactelitenord",
};
